export default __webpack_public_path__ + "static/erica-steeves-mail-4e76c0852a14d0b2248d0630937c4a4f.jpg";